// pages/Careers.jsx
import { useState } from "react";

export default function Careers() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    resume: null,
    cover: "",
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setForm((prev) => ({ ...prev, resume: file }));
  };

  // UI ONLY — No form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("This UI is only for display. Add backend later.");
  };

  return (
    <div className="min-h-screen bg-white py-16 px-4 sm:px-6 lg:px-8 font-roboto">
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

          .font-roboto {
            font-family: "Roboto", sans-serif !important;
          }
        `}
      </style>

      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            Join Our Team
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            Build your future with us — we’re hiring talented people like you.
          </p>
        </div>

        {/* Form */}
        <div className="bg-gray-50 border border-gray-200 shadow-md rounded-xl p-8 md:p-10">
          <form onSubmit={handleSubmit} className="space-y-7">

            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Full Name *
              </label>
              <input
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-gray-700 focus:border-transparent transition"
                placeholder="John Doe"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email Address *
              </label>
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-gray-700 focus:border-transparent transition"
                placeholder="john@example.com"
              />
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Phone (Optional)
              </label>
              <input
                name="phone"
                type="tel"
                value={form.phone}
                onChange={handleChange}
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-gray-700 focus:border-transparent transition"
                placeholder="+91 98765 43210"
              />
            </div>

            {/* Position */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Applying For *
              </label>
              <input
                name="position"
                type="text"
                value={form.position}
                onChange={handleChange}
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-gray-700 focus:border-transparent transition"
                placeholder="Fashion Designer, Developer, etc."
              />
            </div>

            {/* Resume */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Resume / CV *
              </label>
              <input
                name="resume"
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
                className="mt-2 block w-full text-sm bg-white text-gray-700 file:mr-4 file:py-3 file:px-5 file:rounded-lg file:border-0 file:bg-gray-800 file:text-white hover:file:bg-black transition"
              />
              <p className="mt-2 text-xs text-gray-500">Upload PDF or Word file</p>
            </div>

            {/* Cover Letter */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Cover Letter / Message
              </label>
              <textarea
                name="cover"
                rows="5"
                value={form.cover}
                onChange={handleChange}
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-gray-700 focus:border-transparent transition"
                placeholder="Tell us something about yourself..."
              ></textarea>
            </div>

            {/* Submit */}
            <div className="text-right">
              <button
                type="submit"
                className="px-8 py-3 rounded-lg font-semibold text-white bg-gray-900 hover:bg-black transition"
              >
                Submit Application
              </button>
            </div>
          </form>
        </div>

        {/* Footer */}
        <p className="mt-10 text-center text-sm text-gray-500">
          We usually respond within 3–5 business days.
        </p>
      </div>
    </div>
  );
}
